import { Link } from "react-router-dom";

const quickLinks = [
  {
    icon: "ri-compass-3-line",
    title: "平台导航",
    desc: "官方入口地址汇总",
    href: "/category/pingtai-daohang",
    color: "bg-primary-100 text-primary-700",
  },
  {
    icon: "ri-user-add-line",
    title: "注册登录",
    desc: "账号注册与登录指引",
    href: "/category/zhuce-denglu",
    color: "bg-accent-100 text-accent-700",
  },
  {
    icon: "ri-book-open-line",
    title: "使用指南",
    desc: "功能操作详细教程",
    href: "/category/shiyong-zhinan",
    color: "bg-secondary-100 text-secondary-700",
  },
  {
    icon: "ri-shield-check-line",
    title: "安全防护",
    desc: "账户安全与防骗指南",
    href: "/category/anquan-fanghu",
    color: "bg-primary-100 text-primary-700",
  },
];

export default function QuickNavSection() {
  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            快捷导航
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            选择您需要的服务，快速找到对应指引
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {quickLinks.map((link) => (
            <Link
              key={link.title}
              to={link.href}
              className="group flex flex-col items-center p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-full mb-3 ${link.color} transition-transform duration-200 group-hover:scale-110`}>
                <i className={`${link.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {link.title}
              </h3>
              <p className="text-xs text-foreground-500 text-center leading-relaxed">
                {link.desc}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}